module.exports = __webpack_public_path__ + "static/media/splashLogo.61ec25d5.png";